angular.module("warsApp.filters").filter('yesNoFilter', function () {
    return function (input) {
        if (input === true)
            return "Yes";
        return "No";
    }
});